export const discrepancy = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];
